import request from '@/API/request';
//  富媒体上传接口，type 0={普通文件} 1={头像文件} 2={视频文件} 3={office文件}
export function uploadImg(data) {
  return request({
    url: `resource/api/upload`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data', // 必须设置这个请求头
    },
    data,
  });
}
